import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'

// Project Components
import {
    Stack,
    Box,
    Checkbox,
    Link as ChakraLink
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import {useIntl} from 'react-intl'

import {useLocation} from 'react-router-dom'

// Others
import {noop} from '@salesforce/retail-react-app/app/utils/utils'
import {accordionListBtnStyles} from './refinements.style'
//import {rebuildPathWithParams} from '@salesforce/retail-react-app/app/utils/url'
import {pxToRem} from '../../../utills/pxToRem'
import useScrollToMoreButton from '../../../hooks/useScrollToMoreButton'
import {refreshPageForCategoryFilters} from '../../../constants'

const CategoryLinks = ({filter, selectedFilters, onClose = noop}) => {
    const intl = useIntl()
    const [showAll, setShowAll] = useState(false)
    const location = useLocation()
    const {setScrollToMore, moreButtonRef} = useScrollToMoreButton()

    const displayedValues = showAll ? filter.values : filter.values.slice(0, 3)

    const getToggleMessage = () => {
        return showAll
            ? intl.formatMessage({
                  id: 'plp.refinements.less.label',
                  defaultMessage: 'Less Categories'
              })
            : intl.formatMessage({
                  id: 'plp.refinements.more.label',
                  defaultMessage: 'More Categories'
              })
    }

    useEffect(() => {
        setShowAll(false)
    }, [location.pathname])

    const toggleShowAllFilters = () => {
        setScrollToMore(!!showAll)
        setShowAll(!showAll)
    }

    const handleCategoryFilter = (href) => {
        onClose()
        window.location.href = href
    }

    return (
        <Stack spacing={1}>
            {displayedValues?.map((value) => {
                const isChecked = selectedFilters.includes(value.value)
                if (value.hitCount === 0 && !isChecked) return null
                const pageRefreshRequired =
                    refreshPageForCategoryFilters.indexOf(`/${value.value}`) > -1

                const checkBoxToRender = (
                    <Checkbox
                        isChecked={location?.pathname?.split('/')[2] === value?.value}
                        lineHeight={'normal'}
                        sx={{
                            '.chakra-checkbox__label': {
                                marginLeft: pxToRem(7),
                                fontWeight:
                                    location?.pathname?.split('/')[2] === value?.value
                                        ? '500 !important'
                                        : '400 !important'
                            }
                        }}
                    >
                        {value?.label}
                    </Checkbox>
                )
                if (pageRefreshRequired) {
                    return (
                        <ChakraLink
                            as={'a'}
                            display="flex"
                            alignItems="center"
                            key={value?.value}
                            href={`/shop/${value.value}${location?.search}`}
                            onClick={() =>
                                handleCategoryFilter(`/shop/${value.value}${location?.search}`)
                            }
                            _hover={{
                                textDecoration: 'none'
                            }}
                        >
                            {checkBoxToRender}
                        </ChakraLink>
                    )
                }
                return (
                    <Link
                        display="flex"
                        alignItems="center"
                        key={value?.value}
                        href={`/shop/${value.value}${location?.search}`}
                        onClick={onClose}
                        useNavLink
                        _hover={{
                            textDecoration: 'none'
                        }}
                    >
                        {checkBoxToRender}
                    </Link>
                )
            })}
            {filter.values.length > 3 && (
                <Box onClick={toggleShowAllFilters} ref={moreButtonRef} sx={accordionListBtnStyles}>
                    {getToggleMessage()}
                </Box>
            )}
        </Stack>
    )
}

CategoryLinks.propTypes = {
    filter: PropTypes.shape({
        values: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
                hitCount: PropTypes.number
            })
        ).isRequired,
        attributeId: PropTypes.string.isRequired
    }).isRequired,
    toggleFilter: PropTypes.func.isRequired,
    selectedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
    onClose: PropTypes.func.isRequired
}

export default CategoryLinks
